import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConstantsService } from 'app/authority/authority-shared/services/constants.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
  selector: 'amd-authority-consip-preview-quotation-pdf-dialog',
  templateUrl: './authority-consip-preview-quotation-pdf-dialog.component.html',
  styleUrls: ['./authority-consip-preview-quotation-pdf-dialog.component.scss']
})
export class AuthorityConsipPreviewQuotationPdfDialogComponent implements OnInit {

  consipPreview;
  isCarbody: boolean;
  isPositiveTheme: boolean;
	translateContext: TranslateContext = TranslateContext.AUTHORITY;

	constructor(
    @Inject(MAT_DIALOG_DATA) private data, 
    private constantService: ConstantsService,
    public dialogRef: MatDialogRef<AuthorityConsipPreviewQuotationPdfDialogComponent>
  ) {
		this.consipPreview = this.data.consip;
	}
  
  ngOnInit() {
		this.isPositiveTheme = this.constantService.getIsPositiveTheme();
    this.isCarbody = this.consipPreview && this.consipPreview.carbody_data ? true : false;
  }

  getVehicleEntries = () => this.consipPreview ? this.getInfoQuotation().entries : [];
  
  getInfoQuotation = () => this.isCarbody ? this.consipPreview.carbody_data : this.consipPreview.mechanic_data;
}
